import styled, { css } from 'styled-components';
import { theme } from './theme';

// レイアウト
export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${theme.space.xl} ${theme.space.md};

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.space.md};
  }
`;

export const PageWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const MainContent = styled.main`
  flex: 1;
`;

// セクション
export const Section = styled.section`
  margin-bottom: ${theme.space['2xl']};
  padding: ${theme.space.lg} 0;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.space.sm} 0;
    margin-bottom: ${theme.space.lg};
  }
`;

export const SectionTitle = styled.h2`
  font-size: ${theme.fontSizes['3xl']} !important;
  margin-bottom: ${theme.space.lg};
  text-align: center !important;
  position: relative !important;
  padding: ${theme.space.md} 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::before, &::after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 4px !important;
    width: 500px !important;
    background-color: currentColor;
    display: block;
  }
  
  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.fontSizes.xll} !important;
    margin-bottom: ${theme.space.md};
    padding: ${theme.space.md} 0 !important;

    &::before, &::after {
      width: 80px;
    }
  }
`;

export const SectionDescription = styled.p`
  text-align: center;
  max-width: 800px;
  margin: 0 auto ${theme.space.lg};
  color: ${theme.colors.white};
  font-size: ${theme.fontSizes.lg};

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.fontSizes.md};
    margin-bottom: ${theme.space.md};
  }
`;

export const BlueSection = styled(Section)`
  color: ${theme.colors.white};
  padding: ${theme.space.xl} 0;
  position: relative;
  z-index: 1;
  
  ${SectionTitle} {
    color: ${theme.colors.white};
    margin-bottom: ${theme.space.lg};
    
    &::before, &::after {
      background-color: ${theme.colors.white};
    }
  }
  
  ${SectionDescription} {
    color: rgba(255, 255, 255, 0.8);
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.space.md} 0;
    
    ${SectionTitle} {
      margin-bottom: ${theme.space.md};
    }
  }
`;

export const GreenSection = styled(Section)`
  color: ${theme.colors.white};
  padding: ${theme.space.xl} 0;
  position: relative;
  z-index: 1;
  
  ${SectionTitle} {
    color: ${theme.colors.white};
    margin-bottom: ${theme.space.lg};
    
    &::before, &::after {
      background-color: ${theme.colors.white};
    }
  }
  
  ${SectionDescription} {
    color: rgba(255, 255, 255, 0.8);
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.space.md} 0;
    
    ${SectionTitle} {
      margin-bottom: ${theme.space.md};
    }
  }
`;

export const WhiteSection = styled(Section)`
  background-color: transparent;
  position: relative;
  z-index: 1;
  padding: ${theme.space.xl} 0;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.space.md} 0;
  }
`;

// グリッド
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${theme.space.lg};
  margin-bottom: ${theme.space['2xl']};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: ${theme.space.sm};
    margin-bottom: ${theme.space.lg};
  }
`;

// ボタン
export const MoreButton = styled.div`
  text-align: center;
  margin-bottom: ${theme.space['2xl']};
  
  a {
    display: inline-block;
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    padding: ${theme.space.sm} ${theme.space.lg};
    border-radius: ${theme.radii.md};
    font-weight: ${theme.fontWeights.bold};
    transition: ${theme.transitions.default};
    
    &:hover {
      background-color: ${theme.colors.primaryDark};
    }
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    margin-bottom: ${theme.space.lg};
    
    a {
      padding: ${theme.space.sm} ${theme.space.md};
    }
  }
`;

export const ViewAllButton = styled.button`
  background-color: ${theme.colors.accent};
  color: ${theme.colors.white};
  padding: ${theme.space.sm} ${theme.space.lg};
  border: none;
  border-radius: ${theme.radii.full};
  font-size: ${theme.fontSizes.md};
  font-weight: ${theme.fontWeights.bold};
  cursor: pointer;
  transition: ${theme.transitions.default};
  display: block;
  margin: ${theme.space.lg} auto 0;
  
  &:hover {
    background-color: #e55a00;
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.space.sm} ${theme.space.md};
    margin: ${theme.space.sm} auto 0;
    font-size: ${theme.fontSizes.sm};
  }
`;

// ローディング
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;  
  min-height: 300px;
  width: 100%;
`;

export const LoadingSpinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid ${props => props.theme.colors.primary};
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-right: ${theme.space.md};
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.lightText};
`;

// バッジ・ラベル
export const Badge = styled.div`
  background-color: ${theme.colors.accent};
  color: ${theme.colors.white};
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.bold};
  padding: 4px 8px;
  border-radius: ${theme.radii.full};
  display: inline-block;
  position: absolute;
  top: 0;
  left: 8%;
  z-index: 2;
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 3px 6px;
    font-size: 0.7rem;
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 2px 4px;
    font-size: 0.65rem;
    left: 5%;
  }
`; 